import React from 'react';
import { cx } from '../cx';

// D-09 §15.4/§15.19 — Tabs (.tabs / .tabs-pill > a[.active]) · controlled
export interface TabItem {
  label: string;
  value: string;
}
export interface TabsProps extends Omit<React.HTMLAttributes<HTMLElement>, 'onChange'> {
  tabs: TabItem[];
  value: string;
  onChange: (value: string) => void;
  variant?: 'line' | 'pill';
  /** pill 전용 — sm은 높이 control-height-sm(32). 기본 md(40). */
  size?: 'sm' | 'md';
}

export function Tabs({ tabs, value, onChange, variant = 'line', size = 'md', className = '', ...props }: TabsProps) {
  const base = variant === 'pill' ? 'tabs-pill' : 'tabs';
  return (
    <nav className={cx(base, variant === 'pill' && size === 'sm' && 'tabs-pill-sm', className)} {...props} role="tablist">
      {tabs.map((t) => (
        <a
          key={t.value}
          role="tab"
          tabIndex={0}
          aria-selected={t.value === value}
          className={t.value === value ? 'active' : ''}
          onClick={() => onChange(t.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onChange(t.value);
          }}
        >
          {t.label}
        </a>
      ))}
    </nav>
  );
}
